import axios, {AxiosInstance, InternalAxiosRequestConfig, AxiosResponse, AxiosRequestConfig } from 'axios';
import { $enum } from '@/global'
import { AUTH } from '@/config'

const OMS_API_PREFIX = '/gateway/apisvc-uots-oms';

const config = {
    timeout: Number(process.env.VUE_APP_TIMEOUT) || 10000 // 从环境变量获取超时时间
}

interface ResultData<T> {
    code: number | string;
    data: T;
    message: string;
}

interface RequestConfig extends AxiosRequestConfig {
    query?: object;
    [key: string]: any; // 其他配置（如 headers、timeout 等）
}

class RequestHttp {
    service: AxiosInstance;
    constructor(config: AxiosRequestConfig) {
        this.service = axios.create(config);

        const isOmsApi = (url?: string) => (url || '').includes(OMS_API_PREFIX);

        // 请求拦截器
        this.service.interceptors.request.use(
            (config: InternalAxiosRequestConfig) => {
                // 可以在这里添加请求头等配置
                if (config.headers && typeof config.headers.set === "function") {
                    const tokenKey = isOmsApi(config.url) ? 'omsToken' : 'Authorization';
                    config.headers.set("Authorization", `Bearer ${localStorage.getItem(tokenKey) || ''}`);
                }
                return config;
            },
            (error: any) => {
                console.error('请求错误:', error);
                return Promise.reject(error);
            }
        );

        // 响应拦截器
        this.service.interceptors.response.use(
            (response: AxiosResponse) => {
                // 如果响应类型是blob，我们返回整个response
                if (response?.config?.responseType === 'blob') {
                    return response;
                }

                const res = response.data;
                
                if(res.code === $enum.EnumResult.OVERDUE){
                    if (isOmsApi(response?.config?.url)) {
                        return res;
                    }
                    //miss token
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.replace(window.location.origin + `${AUTH}/logout`);
                }
                return res;
            },
            (error: any) => {
                console.error('响应错误:', error);
                return Promise.reject(error);
            }
        );
    }

    /**
    * @description 常用请求方法封装
    */
    get<T>(url: string, params?: object, _object = {}): Promise<ResultData<T>> {
        return this.service.get(url, { params, ..._object });
    }
    post<T>(url: string, body?: object | string | null, config: RequestConfig = {}): Promise<ResultData<T>> {
        const { query, ...axiosConfig } = config;
        return this.service.post(url, body, {
            ...axiosConfig,
            params: query
        });
    }

}

export default new RequestHttp(config);
